import { BehaviorSubject } from 'rxjs';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ToastService {

  public mensaje = new BehaviorSubject('');
  public activo = new BehaviorSubject(false);

  constructor() { }

  public mostrarToast(nuevoMensaje: string, duracion: number = 5000): void {
    this.activo.next(true);
    this.mensaje.next(nuevoMensaje);

    setTimeout(() => this.activo.next(false), duracion)
  }

  public ocultarToast(): void {
    this.activo.next(false);
  }
}
